import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import { initializeGA, trackPageView } from './utils/analytics';
import PageTracker from './components/PageTracker';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Quote from './pages/Quote';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Admin from './pages/Admin';
import AdminProducts from './pages/admin/AdminProducts';
import AdminProductDetail from './pages/admin/AdminProductDetail';
import AdminPricing from './pages/admin/AdminPricing';
import AdminOrders from './pages/admin/AdminOrders';
import AdminOrderDetail from './pages/admin/AdminOrderDetail';
import AdminUsers from './pages/admin/AdminUsers';
import AdminCategories from './pages/admin/AdminCategories';
import Login from './components/Login';
import Register from './components/Register';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './pages/Profile';
import CustomerOrders from './pages/CustomerOrders';
import OrderDetail from './pages/OrderDetail';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import OrderConfirmation from './pages/OrderConfirmation';
import { CartProvider } from './context/CartContext';
import { DataProvider } from './context/DataContext';
import { OrderProvider } from './context/OrderContext';
import { AuthProvider } from './context/AuthContext';
import { PricingProvider } from './context/PricingContext';
import { StripeProvider } from './context/StripeContext';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initializeGA('G-G13V47F3PZ');
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <DataProvider>
          <PricingProvider>
            <OrderProvider>
              <CartProvider>
                <StripeProvider>
                  <Router>
                    <PageTracker />
                    <ScrollToTop />
            <div className="min-h-screen bg-gray-50 flex flex-col">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id/:slug" element={<ProductDetail />} />
                  <Route path="/quote" element={<Quote />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/profile" element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } />
                  <Route path="/orders" element={
                    <ProtectedRoute>
                      <CustomerOrders />
                    </ProtectedRoute>
                  } />
                  <Route path="/orders/:id" element={
                    <ProtectedRoute>
                      <OrderDetail />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin" element={
                    <ProtectedRoute requiredRole="admin">
                      <Admin />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/products" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminProducts />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/products/:id" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminProductDetail />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/pricing" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminPricing />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/orders" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminOrders />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/orders/:id" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminOrderDetail />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/users" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminUsers />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/categories" element={
                    <ProtectedRoute requiredRole="admin">
                      <AdminCategories />
                    </ProtectedRoute>
                  } />
                </Routes>
              </main>
              <Footer />
            </div>
                  </Router>
                </StripeProvider>
              </CartProvider>
            </OrderProvider>
          </PricingProvider>
        </DataProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;